// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__vj_q","svg":"loader_svg_EaKrW","bg":"loader_bg_Vy2MM","animate":"loader_animate_aU8p8","fill-animation":"loader_fill-animation_I6vqq"};